import PageHero from "@/components/jf/PageHero";
import Reveal from "@/components/jf/Reveal";
import { useGo } from "@/components/jf/Nav";

const DETAILS = [
  { k: "Address", v: "Jaipur Furniture Showroom, Malviya Nagar, Jaipur, Rajasthan 302017" },
  { k: "Hours", v: "Mon – Sat · 10:00 AM – 8:00 PM" },
  { k: "Sunday", v: "11:00 AM – 6:00 PM" },
  { k: "Phone", v: "+91 ····· ·······" },
  { k: "Email", v: "hello@jaipurfurniture.com" },
];

const PHOTOS = [
  { src: "/images/showroom-1.jpg", label: "The Storefront" },
  { src: "/images/showroom-2.jpg", label: "The Gallery Floor" },
  { src: "/images/showroom-3.jpg", label: "Woods & Finishes" },
];

export default function VisitPage() {
  const go = useGo();
  return (
    <main>
      <PageHero
        kicker="Visit Us"
        title={<>The showroom, <em className="text-brass-soft font-light">in Malviya Nagar.</em></>}
        accent="J"
      >
        <p className="mt-8 max-w-xl text-ivory/70 font-light leading-relaxed text-base md:text-lg">
          Run your hand over the woods, feel the finishes, sit in the pieces — our Jaipur
          showroom is open all week.
        </p>
      </PageHero>

      <section data-testid="visit-details" className="bg-ivory py-24 md:py-32">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-14 md:gap-20">
          <Reveal>
            <p className="text-oxblood text-xs tracking-[0.45em] uppercase mb-10">Find Us</p>
            <div className="space-y-6">
              {DETAILS.map((d) => (
                <div key={d.k} data-testid={`visit-${d.k.toLowerCase()}`} className="flex gap-6 items-baseline border-b border-oxblood/15 pb-5">
                  <span className="text-oxblood/60 text-[10px] tracking-[0.3em] uppercase w-24 shrink-0">{d.k}</span>
                  <span className="font-display text-oxblood-ink text-lg md:text-xl leading-snug">{d.v}</span>
                </div>
              ))}
            </div>
            <button
              data-testid="visit-book-btn"
              onClick={() => go("book")}
              className="mt-12 bg-oxblood text-ivory hover:bg-oxblood-ink px-10 py-4 text-xs tracking-[0.28em] uppercase transition-colors duration-400"
            >
              Book Before You Visit
            </button>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="border border-oxblood/20 h-full min-h-[420px]">
              <iframe
                data-testid="visit-map"
                title="Jaipur Furniture — Malviya Nagar, Jaipur"
                src="https://www.google.com/maps?q=Malviya%20Nagar%2C%20Jaipur%2C%20Rajasthan&output=embed"
                className="w-full h-full min-h-[420px] grayscale-[35%] contrast-[1.05]"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
      </section>

      <section data-testid="showroom-photos" className="bg-cream py-24 md:py-32">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12">
          <Reveal>
            <p className="text-oxblood text-xs tracking-[0.45em] uppercase mb-6">Inside the Showroom</p>
            <h2 className="font-display text-oxblood-ink text-4xl md:text-6xl leading-tight max-w-2xl">
              Come, <em className="text-oxblood font-light">take a seat.</em>
            </h2>
          </Reveal>
          <div className="mt-14 grid md:grid-cols-3 gap-6">
            {PHOTOS.map((p, i) => (
              <Reveal key={p.src} delay={i * 0.07}>
                <div data-testid={`showroom-photo-${i}`} className="group relative aspect-[4/3] overflow-hidden border border-oxblood/20">
                  <img src={p.src} alt={p.label} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-oxblood-ink/70 to-transparent" />
                  <span className="absolute bottom-5 left-5 font-display italic text-ivory text-xl">{p.label}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
